<div class="accordion accordion-flush fixed-top" style="margin-top: 56px;" id="accordionFlushExample">
  <div class="accordion-item border border-primary" >
    <h2 class="accordion-header" id="flush-headingOne">
      <button class="accordion-button collapsed bg-dark text-white px-4" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        {{ 'scanner.camera' | translate }}
      </button>
    </h2>
  </div>
  <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div class="accordion-body bg-dark text-white container">
        <ul class="list-group-flush bg-dark text-white p-0 m-0">
          <li class="list-group-item bg-dark text-white" style="font-size: 13px;"  (click)="changeCamera(undefined)">No device</li>
          <li *ngFor="let camera of devices; index as i" style="font-size: 13px;" class="list-group-item bg-dark mt-3" (click)="changeCamera(camera)" [ngClass]="scanner.device===camera ? 'text-warning fw-bold' : 'text-white'">
              #{{i+1}} - {{ camera.label }}
          </li>
        </ul>
      </div>
    </div>
</div>
<div class="position-relative">

    <zxing-scanner #scanner
        [enable]="true"
        previewFitMode="cover"
        [formats]="allowedFormats"
        (scanSuccess)="scanSuccessHandler($event)"
        (camerasFound)="onCamerasFound($event)"
        (torchCompatible)="onTorchCompatible($event)"
        [tryHarder]="true"
    ></zxing-scanner>

    <div *ngIf="torchCompatible" class="torch-button" (click)="toggleTorch()"><i class="bi bi-lightbulb" [class.bi-lightbulb-fill]="scanner.torch"></i></div>

    <div class="scan-frame"></div>

    <ngx-spinner type="ball-scale-multiple" size="medium" [fullScreen]="false">{{ 'scanner.loading' | translate }}</ngx-spinner>

</div>
